<template>
  <div class="filter">
    <div class="filter-header">
      <div>查询搜索</div>
      <el-button
        type="text"
        style="margin-left: auto"
        :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
        @click="toggleFilter"
        >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
      >
    </div>

    <el-collapse-transition>
      <div v-show="!filterFold">
        <div class="filter-content">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="赔付单ID">
              <el-input
                v-model="form.scId"
                placeholder="赔付单ID"
                clearable
                @clear="handleIdClear"
              ></el-input>
            </el-form-item>

            <el-form-item label="赔付原因">
              <el-select
                v-model="form.type"
                multiple
                placeholder="赔付原因"
                style="width: 200px"
              >
                <el-option label="货期超时" value="1"></el-option>
                <el-option label="缺货断货" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="处理状态">
              <el-select
                v-model="form.status"
                multiple
                placeholder="状态"
                style="width: 200px"
              >
                <el-option label="待赔付" value="1"></el-option>
                <el-option label="已完成" value="2"></el-option>
                <el-option label="已作废" value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="商家名称">
              <el-input
                v-model="form.supplyName"
                placeholder="商家名称"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="商家ID">
              <el-input
                v-model="form.supplyId"
                placeholder="商家ID"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="赔付单生成时间">
              <el-date-picker
                v-model="form.createdTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="(val) => handleDateChange(val, 'createdTime')"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="赔付单完成时间">
              <el-date-picker
                v-model="form.completeTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="(val) => handleDateChange(val, 'completeTime')"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button type="success" @click="handleExport"
                >导出列表</el-button
              >
              <el-button type="success" @click="handleExportDetail"
                >导出商品明细</el-button
              >
              <el-button @click="handleCompensationSetting">赔付设置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: "SearchForm",
  props: {
    // 接收父组件的表单数据
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterFold: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 只限制不能选择未来日期
        },
        onPick: ({ maxDate, minDate }) => {
          if (minDate && !maxDate) {
            const thirtyOneDaysLater = new Date(minDate);
            thirtyOneDaysLater.setDate(minDate.getDate() + 31);
            this.pickerOptions.disabledDate = (time) => {
              return (
                time.getTime() > Date.now() ||
                time.getTime() > thirtyOneDaysLater.getTime() ||
                time.getTime() < minDate.getTime() - 24 * 60 * 60 * 1000 * 31
              );
            };
          }
        },
      },
    };
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    // // 初始化时设置最近2天日期范围
    // const today = this.formatDate(new Date());
    // const yesterday = this.formatDate(this.getYesterday());
    // this.$emit("input", {
    //   ...this.value,
    //   createdTime: [],
    //   completeTime: [],
    // });
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    getYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday;
    },

    getTodayDateRange() {
      const today = this.formatDate(new Date());
      return [`${today} 00:00:00`, `${today} 23:59:59`];
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },

    handleIdClear() {
      this.$emit("id-clear");
    },

    handleDateChange(val, dateType) {
      if (val) {
        const [start, end] = val;
        this.form[dateType] = [`${start} 00:00:00`, `${end} 23:59:59`];
      } else {
        this.form[dateType] = null;
      }
    },

    validateSearch() {
      const { scId, createdTime, completeTime } = this.form;

      if (scId) {
        return true;
      }

      const hasTimeCondition = createdTime || completeTime;
      if (!hasTimeCondition) {
        this.$message.error("请选择31天内的任意日期进行查询");
        return false;
      }

      const validateTimeRange = (timeRange) => {
        if (!timeRange) return true;
        const [start, end] = timeRange;
        const startDate = new Date(start.split(" ")[0]);
        const endDate = new Date(end.split(" ")[0]);
        const days = (endDate - startDate) / (24 * 60 * 60 * 1000);
        return days <= 31;
      };

      if (![createdTime, completeTime].every(validateTimeRange)) {
        this.$message.error("请选择31天内的任意日期进行查询");
        return false;
      }

      return true;
    },

    handleSearch() {
      if (!this.validateSearch()) return;
      this.$emit("search", this.form);
    },

    handleExport() {
      if (!this.validateSearch()) return;
      this.$emit("export");
    },

    handleExportDetail() {
      if (!this.validateSearch()) return;
      this.$emit("export-detail");
    },

    handleCompensationSetting() {
      this.$emit("compensation-setting");
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}

.filter-header {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
}

.filter-content {
  padding: 10px 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantClaimsOrder/components/SearchForm.vue